var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_407_162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.42859 16.2857C4.14287 17.5714 4.14287 14.1428 2.42859 13.7143M14.4286 18.8571V15.54C14.4607 15.1313 14.4055 14.7204 14.2666 14.3347C14.1277 13.9489 13.9082 13.5972 13.6229 13.3028C16.3143 13.0028 19.1429 11.9828 19.1429 7.30285C19.1427 6.10613 18.6823 4.9553 17.8572 4.08856C18.2479 3.04157 18.2203 1.88429 17.78 0.857133C17.78 0.857133 16.7686 0.557133 14.4286 2.1257C12.464 1.59327 10.3932 1.59327 8.42859 2.1257C6.08859 0.557133 5.07716 0.857133 5.07716 0.857133C4.63691 1.88429 4.60928 3.04157 5.00002 4.08856C4.1687 4.96173 3.70789 6.12296 3.7143 7.32856C3.7143 11.9743 6.54287 12.9943 9.2343 13.3286C8.9523 13.62 8.73481 13.9675 8.596 14.3485C8.45718 14.7295 8.40014 15.1355 8.42859 15.54V18.8571",
    stroke: "white",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_407_162"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.5714,
    height: 20.5714,
    fill: "white",
    transform: "translate(0.714294)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.a3f9da21846507ad8470f9e31dc2a12f.svg";
export { ForwardRef as ReactComponent };